import styled from 'styled-components';
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next';

const BannerContainer = styled.div<{ img?: string }>`
    max-width: 100vw;
    padding: 30px;

    font-size: 30px;
    font-weight: bold;
    display: inline-block;
    
    background-color: transparent;
    width: 100%;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    ${({ img }) => {        
        if (!img) {
            return `color: #092c46;`
        }

        return `
            color:rgb(244, 250, 255);
            text-shadow: 0 0 10px #3e7dc0;
            background-image: linear-gradient(to bottom, #f5f6fc85, #3e7dc0d6), url(${img})
        `
    }}
`

function getBannerImage(estate: string) {
    switch (estate) {
        case 'CUR':
        case 'RCR':
            return require('./banners/cur.jpg').default
        case 'SAM':
            return require('./banners/sam.jpg').default
        case 'PLD':
            return require('./banners/pep.jpg').default
        case 'HOB':
            return require('./banners/tfg.jpg').default
        case 'BEN':
            return require('./banners/ben.jpg').default
        default:
            return undefined
    }
}

function EstateBanner() {
    const { estate }  = useParams<{ estate: string; }>()
    const { t } = useTranslation()
    const bannerImg = getBannerImage(estate)

    return (
        <BannerContainer img={bannerImg}>
            {t('Stores')}
        </BannerContainer>
    )
}

export default EstateBanner